import React from 'react';

export type ConnectWalletContextType = {
  tokenAddress: string;
  connectWalletCallback: () => Promise<string | undefined>;
  disconnectWalletCallback: () => Promise<void>;
  setTokenAddress: React.Dispatch<React.SetStateAction<string>>;
  switchNetworkCallback: () => Promise<void>;
};

export const ConnectWalletContext = React.createContext<ConnectWalletContextType>({
  tokenAddress: '',
  connectWalletCallback: async () => {
    return undefined;
  },
  disconnectWalletCallback: async () => {},
  setTokenAddress: () => {},
  switchNetworkCallback: async () => {},
});
